(()=>{
  document.querySelectorAll('[data-ns-hats]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='1';
    const params=new URLSearchParams(location.search),key='ns-game-hats-unlocked';
    const mode=['session','local','none'].includes(params.get('persistence'))?params.get('persistence'):root.dataset.persistence;
    const readAward=()=>{
      try{const storage=mode==='local'?localStorage:sessionStorage;const awarded=storage.getItem(key)==='1';if(mode==='none'&&awarded)storage.removeItem(key);return awarded}catch{return false}
    };
    let unlocked=readAward(),departedForCart=false;
    const applyGate=()=>{
      root.querySelector('[data-hats-lock]').hidden=unlocked;
      root.querySelector('[data-hats-reward]').hidden=!unlocked;
      if(!unlocked){root.querySelectorAll('dialog').forEach(dialog=>{if(dialog.open)dialog.close()});document.documentElement.classList.remove('ns-hat-modal-open')}
    };
    const revokeForCart=()=>{
      for(const name of ['sessionStorage','localStorage'])try{window[name].removeItem(key)}catch{}
      unlocked=false;departedForCart=true;applyGate();
    };
    const isCartDestination=href=>{
      try{
        const url=new URL(href,location.href),cart=new URL(root.dataset.cartUrl,location.href);
        const path=url.pathname.replace(/\/+$/,'');
        return url.origin===location.origin&&(path===cart.pathname.replace(/\/+$/,'')||/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?cart$/i.test(path)||/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?checkouts?(?:\/|$)/i.test(path));
      }catch{return false}
    };
    const cartNavigation=event=>{
      if(event.defaultPrevented||event.button>1)return;
      const link=event.target.closest?.('a[href]');
      if(link&&isCartDestination(link.href))revokeForCart();
    };
    document.addEventListener('click',cartNavigation);
    document.addEventListener('auxclick',cartNavigation);
    document.addEventListener('submit',event=>{if(!event.defaultPrevented&&isCartDestination(event.target.action))revokeForCart()});
    window.addEventListener('pageshow',()=>{
      if(mode!=='none'||departedForCart)unlocked=readAward();
      departedForCart=false;applyGate();return refreshCart();
    });
    applyGate();
    root.querySelectorAll('[data-ns-preview-link]').forEach(a=>{const u=new URL(a.href);const preview=params.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);a.href=u.pathname+u.search});
    let opener=null;
    root.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-hat-open]');
      if(trigger&&unlocked){const dialog=document.getElementById(trigger.dataset.hatOpen);if(!dialog)return;opener=trigger;dialog.showModal();document.documentElement.classList.add('ns-hat-modal-open');return}
      const close=event.target.closest('[data-hat-close]');if(close)close.closest('dialog').close();
      const thumb=event.target.closest('[data-hat-photo]');if(thumb){const gallery=thumb.closest('.ns-hat-gallery'),img=gallery.querySelector('.ns-hat-main');img.removeAttribute('srcset');img.src=thumb.dataset.hatPhoto;img.alt=thumb.dataset.hatAlt;gallery.querySelectorAll('[data-hat-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)))}
      if(event.target.matches('dialog')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close()}
    });
    root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{document.documentElement.classList.remove('ns-hat-modal-open');opener?.focus()}));
    let cartRefresh=0;
    const refreshCart=async()=>{
      const request=++cartRefresh;
      try{
        const result=await fetch(root.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});
        if(!result.ok)return;
        const cart=await result.json();
        if(request===cartRefresh&&Number.isInteger(cart.item_count))document.querySelectorAll('.ns-bag span').forEach(badge=>badge.textContent=String(cart.item_count));
      }catch{}
    };
    root.querySelectorAll('[data-hat-form]').forEach(form=>form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('[type=submit]');
      if(!unlocked||!button||button.disabled)return;
      if(!form.checkValidity()){form.reportValidity();return}
      const status=form.querySelector('[data-hat-status]');
      button.disabled=true;status.textContent='';
      try{
        const result=await fetch(form.action+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        const data=await result.json();
        if(!result.ok)throw Error(data.description||status.dataset.error);
        status.textContent=status.dataset.success;
        const bagLink=form.querySelector('[data-hat-view-bag]');if(bagLink)bagLink.hidden=false;
        await refreshCart();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }catch(error){status.textContent=error.message||status.dataset.error}
      finally{button.disabled=false}
    }));
  });
})();
